<template>
   <form @submit.prevent="validate('usercontact')" data-vv-scope="usercontact" class="row">
      <div class="col-12">
         <form-message :messages="getMessage( 'usercontact')"></form-message>
         <div class="row">
            <vee-input
                v-model="form.iban.value"
                class="col-12 required"
                scope="usercontact"
                name="iban"
                :disabled="!ibanEditableText"
                :spellcheck="false"
                :data-vv-as="t('field.iban')"
                v-validate="rules.value"
                id="userdata__iban">
										<span slot="label" class="account__block__label">
											{{ t('page.user.data.iban') }}
										</span>
               <div slot="validate"
                   v-if="errors.firstByRule('usercontact.iban', 'regex')"
                   class="invalid-feedback d-block">
                  <t tag="register.iban.invalid"></t>
               </div>
            </vee-input>
         </div>
         <div>
            <div class="row">
               <div class="col-12 account__block__label d-flex align-items-center flex-wrap">
                  {{ t('page.user.data.iban.upload') }}
                  <div class="custom-file register__file userdata__file_id ml-2">
                     <input type="file" @change="processFile($event, form.iban, 'file')"
                         v-validate="rules.file"
                         name="ibanFile"
                         :disabled="!ibanEditable"
                         class="custom-file-input"
                         id="userdata__iban-photo"
                         accept="image/*,application/pdf"
                         :data-vv-as="t('field.iban.image')">
                     <label class="custom-file-label" for="userdata__iban-photo"
                         :class="{ 'disabled': !ibanEditable}"
                     >
                                       <span v-if="!form.iban.file.length">{{
                                             t('user.page.userdata.iban.upload.hint')
                                          }}</span>
                        <div :style="'background-image: url('+getFileIcon(cimi.src)+');'"
                            v-for="(cimi, index) in form.iban.file"
                            :key="'iban-file_'+index"
                            class="register__img-preview">
                        </div>
                     </label>
                  </div>
                  <div v-if="isInValid('usercontact.ibanFile')"
                      class="invalid-feedback"
                      :class="{ 'd-block': isInValid('usercontact.ibanFile') }">
                     {{ errors.first('usercontact.ibanFile') }}
                  </div>
                  <div class="valid-feedback d-block" v-if="user.bank_account_upload_status">
                     <t tag="page.user.data.bank.uploaded"></t>
                  </div>
                  <div class="valid-feedback d-block" v-if="user.bankaccountstatus">
                     <t tag="page.user.data.bank.validated"></t>
                  </div>
               </div>
            </div>
            <div class="row mt-4" v-if="isSubmit('usercontact')">
               <div class="col-12 d-flex justify-content-end">
                  <button class="btn btn-primary btn-sm" type="submit">
                     {{ t('general.btn.submit') }}
                  </button>
               </div>
            </div>
         </div>
      </div>
   </form>
</template>

<script>
import Vuex from 'vuex';
import VeeInput from '@/components/ValidateInput';
import FormMessage from '@/components/parts/form-message';
import {IbanRules, mixins} from "@/components/user/UserData/user_helpers";
import {regex} from "@/config";

export default {
   name: "payment_account",
   mixins:[mixins],
   components: {
      VeeInput,
      FormMessage,

   },
   data() {
      return {

         loading: [],


         form: {

            iban: {
               value: '',
               file: [],
               regex: regex.iban
            }
         },
         rules:{
            value: { required: true, regex: regex.iban },
            file: {
               required: false, //true
               ext:[
                  'jpg',
                  'png',
                  'bmp',
                  'svg',
                  'pdf',
               ]
            }
         }
      }
   },
   computed:{
      ...Vuex.mapState([
         'lang',
         'loaderList'
      ]),
      ...Vuex.mapGetters({
         user: 'getUser',
         userLogedIn: 'getUserStatus',
         details: 'getUserDetails'
      }),

      ibanEditableText() {

         for (let rule of IbanRules) {

            if (!rule(this.user, this.details, 'text')) {
               return false
            }
         }

         return true;

         /*if(this.user){

           if(this.user.bank_account_upload_status || this.user.bankaccountstatus || this.user.image_upload_completed){
             //If iban_image already uploaded - then block any further changes
             return false;
           }
           //Otherwise edit possible
           return true
         }


         return false;*/
      },
      ibanEditable() {

         for (let rule of IbanRules) {

            if (!rule(this.user, this.details, 'image')) {
               return false
            }
         }

         return true;
         /*if(this.user){
           if(this.user.bank_account_upload_status && !this.user.bankaccountstatus){
             // Customer are able to upload IBAN even if its already uploaded, till account wasnt validated.
             return true;
           }

           if(this.user.bank_account_upload_status || this.user.bankaccountstatus || this.user.image_upload_completed){
             //If iban_image already uploaded - then block any further changes
             return false;
           }
         }
         return false;*/
      }
   },
   mounted(){
      if (this.details && this.details.bankaccount) {
         this.form.iban.value = this.details.bankaccount;
      }
   },
   methods:{
      validate(scope) {
         this.$validator.validateAll(scope).then((result) => {

            if (result) {
               this.deleteMessage(scope);
               this.updateIBAN();
            }


         });
      },
      //Update IBAN
      updateIBAN() {

         if (this.ibanEditable) {
            //Show loading bar
            this.addLoad('usercontact');

            //Push to vuex new data values to send it to REST
            this.$store.dispatch('saveUserData', {
               'iban': this.form.iban.value,
               'iban_image': this.form.iban.file
            }).then((responce) => {

               //Finish load bar
               this.endLoad('usercontact');

               //Error handling
               if (responce.data.status === 'SUCCESS') {

                  //Show message that all successfully changed
                  this.addMessage({
                     scope: 'usercontact',
                     state: 'success',
                     text: this.t('user.data.payment.change.success')
                  });


                  setTimeout(() => {
                     this.form.iban.value = this.details.bankaccount;
                     this.form.iban.file = [];
                     this.errors.clear('usercontact');
                  }, 50);
               } else {
                  //Show message that some error has occurred

                  let msg;
                  if (typeof responce.data.error !== 'undefined') {
                     msg = this.t('userdata.error.' + responce.data.error.code);
                  } else {
                     msg = responce.data.message
                  }
                  this.addMessage({
                     scope: 'usercontact',
                     state: 'danger',
                     text: msg
                  });
               }

            })
         }


      },
   }
}
</script>

<style scoped>

</style>
